import React, { useEffect, useState } from "react";
import CustomButton from "../../../Atoms/Buttons/CustomButton";
import CustomTextField from "../../../Atoms/TextFields/CustomTextField";
import IconAndTextButton from "../../../Atoms/Buttons/IconAndTextButton";
import Tag from "../../../Atoms/Tag";
import "../../css/classif.sec.css";
import { useAgent } from "../../../../contexts/AgentsContext";

const SkillsSec = () => {
  const { ongoingAgentData, updateOngoingAgentDataL3 } = useAgent();

  const defaultSkills = ["Skill 1", "Skill 2", "Skill 3"];

  const [skills, setSkills] = useState([]);
  const [skillInput, setSkillInput] = useState("");
  const [createSkillClicked, setCreateSkillClicked] = useState(false);
  const [isUserInteracting, setIsUserInteracting] = useState(false);

  useEffect(() => {
    if (isUserInteracting) return;

    const existingSkills = ongoingAgentData?.classifications?.[0]?.skills || [];

    if (existingSkills.length > 0) {
      const allSkills = existingSkills.map((skill) => ({
        name: skill,
        selected: true,
      }));
      setSkills(allSkills);
    } else {
      const defaultSkillsArray = defaultSkills.map((skill) => ({
        name: skill,
        selected: false,
      }));
      setSkills(defaultSkillsArray);
    }
  }, [ongoingAgentData?.classifications?.[0]?.skills, isUserInteracting]);

  const updateSkillsInContext = (updatedSkills) => {
    const selectedSkillNames = updatedSkills
      .filter((skill) => skill.selected)
      .map((skill) => skill.name);

    setIsUserInteracting(true);
    updateOngoingAgentDataL3("skills", selectedSkillNames);
  };

  const handleClickSkillTag = (skill) => {
    const updatedSkills = skills.map((skillItem) =>
      skillItem.name === skill.name
        ? { ...skillItem, selected: !skillItem.selected }
        : skillItem
    );

    setSkills(updatedSkills);
    updateSkillsInContext(updatedSkills);
  };

  const handleRemoveSkillTag = (e, skillToRemove) => {
    e.stopPropagation();

    const totalSkillsCount = skills.length;

    if (totalSkillsCount <= 1) {
      return;
    }

    const updatedSkills = skills.filter(
      (skill) => skill.name !== skillToRemove.name
    );

    setSkills(updatedSkills);
    updateSkillsInContext(updatedSkills);
  };

  const handleCreateSkillBtn = (e) => {
    e.preventDefault();
    setCreateSkillClicked(true);
  };

  const handleCreateSkillAddBtn = (e) => {
    e.preventDefault();

    if (skillInput.trim()) {
      const skillExists = skills.some(
        (skill) => skill.name.toLowerCase() === skillInput.trim().toLowerCase()
      );

      if (!skillExists) {
        const updatedSkills = [
          ...skills,
          { name: skillInput.trim(), selected: true },
        ];
        setSkills(updatedSkills);
        updateSkillsInContext(updatedSkills);
      }

      setSkillInput("");
    }

    setCreateSkillClicked(false);
  };

  const handleCreateSkillCancelBtn = (e) => {
    e.preventDefault();
    setSkillInput("");
    setCreateSkillClicked(false);
  };

  return (
    <section className="">
      <label className="mas-form-label-regular">
        {"Skills"}
        <span className="marketplace-req-asterik">*</span>
        <span className="mas-gray-seven-txt">{" (Minimum 1 Skill)"}</span>
      </label>

      <section className="d-flex gap-2">
        <div className="d-flex flex-wrap gap-2 align-items-center">
          {skills.map((skill, index) => (
            <Tag
              key={index}
              text={skill.name}
              clsNames="mas-tag-multi-select"
              styles={{
                cursor: "pointer",
                backgroundColor: skill.selected
                  ? "var(--db-secondary-blue-nine)"
                  : "var(--db-primary-white)",
              }}
              withIconFunc={true}
              onClickFnTag={() => handleClickSkillTag(skill)}
              onClickFnIcon={(e) => handleRemoveSkillTag(e, skill)}
            />
          ))}
          {!createSkillClicked && (
            <IconAndTextButton
              icon={<span style={{ fontSize: 20 }}>+</span>}
              text="Create Skills"
              iconPos="left"
              iconStyles={{ fontSize: 20, marginRight: 4 }}
              clsNames="mas-plus-icon-btn-2"
              onClickFn={handleCreateSkillBtn}
              styles={{ margin: "auto" }}
            />
          )}
        </div>

        <div className="d-flex gap-3 align-items-center ps-3">
          {createSkillClicked && (
            <>
              <CustomTextField
                clsNames="custom-text-field-container"
                placeholder="Type name"
                handleOnChange={(e) => setSkillInput(e.target.value)}
                value={skillInput}
              />
              <CustomButton
                label="Cancel"
                clsNames="mas-secondary-btn-2 mas-btn-lg"
                onClickFn={handleCreateSkillCancelBtn}
              />
              <CustomButton
                clsNames="mas-secondary-btn-3 mas-btn-lg"
                label="Add"
                onClickFn={handleCreateSkillAddBtn}
                disabled={!skillInput.trim()}
              />
            </>
          )}
        </div>
      </section>
    </section>
  );
};

export default SkillsSec;
